import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css'
})
export class SearchComponent {
  @Input() placeholder = 'Pesquisar';
  @Input() icone = './assets/icones/redesign/inputs/icon-search-input.svg';
  @Input() valor = '';
  @Input() disabled = false;
  @Input() largura = '400px';

  @Output() valorChange = new EventEmitter<string>();

  aoDigitar(valor: string) {
    this.valor = valor;
    this.valorChange.emit(valor);
  }
}
